var tableBreakTags = function tableBreakTags(state) {
  var tokens = state.tokens;

  // Find all table tokens
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    // Check if we're inside a table
    if (token.type === 'table_open') {
      // Process all tokens until the matching table_close
      var j = i + 1;
      while (j < tokens.length && tokens[j].type !== 'table_close') {
        var _tokens$j, _tokens$j2, _tokens$j3;
        // If we're in a table cell content
        if (tokens && ((_tokens$j = tokens[j]) === null || _tokens$j === void 0 ? void 0 : _tokens$j.type) === 'inline' && (_tokens$j2 = tokens[j]) !== null && _tokens$j2 !== void 0 && _tokens$j2.children && (_tokens$j3 = tokens[j]) !== null && _tokens$j3 !== void 0 && (_tokens$j3 = _tokens$j3.children) !== null && _tokens$j3 !== void 0 && _tokens$j3.length) {
          var _tokens$j4;
          // Process the content of the cell
          var children = (_tokens$j4 = tokens[j]) === null || _tokens$j4 === void 0 ? void 0 : _tokens$j4.children;
          if (!children) {
            continue;
          }
          for (var k = 0; k < children.length; k++) {
            var child = children[k];
            if (!child) {
              continue;
            }

            // Replace <br>, <br/>, and <br /> tags with newlines
            // Match different variations of <br> tags
            var brRegex = /<br\s*\/?>/gi;
            if (brRegex.test(child.content)) {
              child.content = child.content.replace(brRegex, '\n');

              // If the content is now just a newline, change the token type
              if (child.content === '\n') {
                child.type = 'hardbreak';
              }
            }
          }
        }
        j++;
      }

      // Skip to the end of the table
      i = j;
    }
  }
  return;
};
export default (function (md) {
  return md.core.ruler.push('table-break-tags', tableBreakTags);
});